import { useEffect } from "react";

import { usePrevious } from "app/components/hooks/usePrevious";
import { flagHasChanged } from "app/pages/workspace/sales/helpers";

const useActionAfterFlagChange = (flag: boolean, action: () => void, condition = true) => {
    const prevFlag = usePrevious(flag);
    const done = flagHasChanged(prevFlag, flag);

    useEffect(() => {
        if (done && condition) {
            action();
        }
    }, [done]);
};

export default useActionAfterFlagChange;
